import { render } from "./Campaign.vue?vue&type=template&id=5a94ed94&scoped=true"
import script from "./Campaign.vue?vue&type=script&lang=js"
export * from "./Campaign.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-5a94ed94"

export default script